

import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { UserService, ContextService, CartService } from '../../shared';
import { Panier, LignePanier } from '../../shared';
// import { RequestOptions } from '@angular/http';
//import { HttpHeaders, HttpParams } from '@angular/common/http';
import {ElementRef} from '@angular/core';
import { Http } from "@angular/http";


@Component({
  selector: 'app-validation',
  templateUrl: './validation.component.html',
  styleUrls: ['./validation.component.scss']
})
export class ValidationComponent implements OnInit {

  @ViewChild('fileInput') fileInput;

  panier: Panier;
  articles: Array<LignePanier>;
  adoptions: Array<LignePanier>;
  uploaded: Array<any> = [];
  context: string;
  count_inputs: number = 0;
  total_upload: number = 0;
  total_adoption: number = 0;
  check: boolean = false;
  hasPreuve: boolean = false;
  loading: boolean = false;
  alert: string;

  constructor(
    private userService: UserService,
    private contextService: ContextService,
    private cartService: CartService,
    private router: Router,
    private http: Http
  ) { }

  ngOnInit() {
    this.context = this.contextService.getContext();
    //this.panier = this.cartService.getLocalCart();
    this.cartService.getUserCart().subscribe(
          data => {
            this.panier = data;
            if(this.panier!=null) this.articles = this.panier.lignePanier;
          if(this.panier!=null) {
            this.adoptions = this.getAdoptions(this.articles);
            console.log(this.adoptions)
          }
          
          }
         );

 
    
    
  }

  onSubmit(){
    if(!this.hasPreuve) return;

    // let fileBrowser = this.fileInput.nativeElement;
    // if (fileBrowser.files && fileBrowser.files.length > 0) {
    //   const formData = new FormData();
    //   for(var i=0; i < fileBrowser.files.length; i++){
    //     let item = fileBrowser.files[i];
   

    //        if(item.size>1000000){
    //         this.alert='Attention le poids de votre fichier dépasse 1 mo';
    //       }

    //        let newname = new Date().getTime().toString()+i;
    //       let fileExtension = '.' + item.name.split('.').pop();
    //       formData.append(`file[${i}]`, item, newname+fileExtension);

    //   }

      if(this.uploaded.length == 0) return;
        const formData = new FormData();
        let i = 0;
        this.uploaded.forEach( file => {
          let newname = new Date().getTime().toString() + i;
          let fileExtension = '.' + file.file.name.split('.').pop();
          formData.append(`file[${i}]`, file.file, newname + fileExtension);
          file.value = newname + fileExtension;
          i++;
        });

       this.cartService.upLoadFile(formData).subscribe(
          data => console.log(data),
          error => console.log("Error! ", error)
        );

    let __preuvesAchat = {};
    this.uploaded.forEach(item => {
      __preuvesAchat[item.key] = item.value;
    })

    sessionStorage.setItem('preuveachat_kne', JSON.stringify({
        preuvesAchat : __preuvesAchat,
        preuvesAchatPapier :  this.check

     }));

    // console.log(__preuvesAchat)
  
    if(this.context == 'B2B'){
      this.router.navigate(['/adresses']);
    } else {
      /// redirection vers les adresses
      this.router.navigate(['/familles/adresses']);
    }
    
  }


  getAdoptions(articles: Array<LignePanier>){
    let adoptions: Array<LignePanier> = this.articles.filter( a => a.indicateurAdoption == true );
    return adoptions;
  }

  fileChange(event) {

    let fileBrowser = this.fileInput.nativeElement;
    if (fileBrowser.files && fileBrowser.files.length > 0) {

      for(var i=0; i < fileBrowser.files.length; i++){
        if(fileBrowser.files[i].size > 1000000){
          this.alert = 'Impossible de charger ce fichier car il fait plus de 1mo.';
          break;
        }
        let uploadline = { key: i, value: fileBrowser.files[i].name, file: fileBrowser.files[i] };
        if(this.uploaded.filter( file => file == uploadline ).length == 0) this.uploaded.push(uploadline);
      }

      if(this.uploaded.length >= 1 && this.uploaded.length <= this.adoptions.length){
        this.hasPreuve = true;
      } else {
        this.hasPreuve = false;
      }

    }

  }

  removeFromUploaded(item){
    this.uploaded = this.uploaded.filter( u => (u != item));

    if(this.uploaded.length < 1 || this.uploaded.length > this.adoptions.length) {
      this.hasPreuve = false;
    } else {
      this.hasPreuve = true;
    }
  }

  chekIt(){
    this.hasPreuve=!this.check;
  }


}



// WEBPACK FOOTER //
// ./src/app/user/_validation/validation.component.ts